import { m } from 'framer-motion';

import IconButton from '@mui/material/IconButton';

import { varHover } from 'src/components/animate';
import { useSettingsContext } from 'src/context/theme-settings-context';
import { useTranslation } from 'src/hooks/use-translation';

import MoonSvg from 'icons/monochrome/moon.svg';
import SunSvg from 'icons/monochrome/sun.svg';

// ----------------------------------------------------------------------

export function ThemeModeToggle() {
  const { t } = useTranslation('', { keyPrefix: 'header' });
  const { themeMode, onUpdate } = useSettingsContext();

  const isDark = themeMode === 'dark';

  return (
    <IconButton
      data-testid="header-theme-mode"
      aria-label={t(isDark ? 'theme-light' : 'theme-dark')}
      component={m.button}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      onClick={() => onUpdate('themeMode', isDark ? 'light' : 'dark')}
      sx={{ width: 40, height: 40 }}
    >
      {isDark ? <SunSvg width={22} /> : <MoonSvg width={22} />}
    </IconButton>
  );
}
